<div>
  <div class="top-toolbar"></div>
  <router-outlet></router-outlet>
</div>
